import React from 'react'
import { createContextHoc } from 'legacy/contexts/utils'
import { type WarehouseWithLocations } from 'utils/contexts/warehouse/queries/warehouse'
import { type ApiDataState } from 'legacy/common/types'
import { type WarehouseLocationFeature } from 'legacy/common/warehouseLocations'
import { type FeatureToggle } from '__codegen__/api'

export type WarehouseContextValue = ApiDataState<{
  warehouse: WarehouseWithLocations
  locationFeatures: WarehouseLocationFeature[]
  partnerName: string
  partnerId: number
  featureToggles: FeatureToggle[]
}>

export const WarehouseContext = React.createContext<WarehouseContextValue | null>(null)

WarehouseContext.displayName = 'WarehouseContext'

export const withWarehouseContext = createContextHoc(WarehouseContext, {
  displayName: 'withWarehouseContext',
  required: true,
})
